//This component is responsible for parsing string as html that is passed in from the caller.
export default function ParseHTML(html: string) : JSX.Element{
    return <span dangerouslySetInnerHTML={{__html: html}} />;
}